import _get from "lodash/fp/get";
import { Link, useConfig } from 'docz';
import React from 'react';
import TimeAgo from 'react-timeago';
import usePrevNext from '../../hooks/usePrevNext';
import { Container, Navigation, Updated } from './custom-styles';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Footer = function Footer(_ref) {
  var menus = _ref.menus,
      updated = _ref.updated;

  var _useConfig = useConfig(),
      _useConfig$menuDispla = _useConfig.menuDisplayName,
      menuDisplayName = _useConfig$menuDispla === void 0 ? {} : _useConfig$menuDispla,
      _useConfig$themeConfi = _useConfig.themeConfig.footer;

  _useConfig$themeConfi = _useConfig$themeConfi === void 0 ? {} : _useConfig$themeConfi;
  var _useConfig$themeConfi2 = _useConfig$themeConfi.navigation,
      navigation = _useConfig$themeConfi2 === void 0 ? true : _useConfig$themeConfi2;

  var _usePrevNext = usePrevNext(menus),
      prev = _usePrevNext.prev,
      next = _usePrevNext.next;

  if (!navigation && !updated) {
    return null;
  }

  var buildPath = function buildPath(path) {
    if (!path || !path.length) return null;
    return path.map(function (i) {
      return _get(i, menuDisplayName) || i;
    }).join(' / ');
  };

  return ___EmotionJSX(Container, null, navigation && (prev || next) ? ___EmotionJSX(Navigation, {
    className: "footer-nav"
  }, ___EmotionJSX("div", {
    className: "row"
  }, prev ? ___EmotionJSX("div", null, ___EmotionJSX(Link, {
    to: prev.item.route,
    href: prev.item.route,
    className: "prev cta"
  }, ___EmotionJSX("div", {
    className: "icon"
  }, ___EmotionJSX("span", null, "\u2039")), ___EmotionJSX("div", null, ___EmotionJSX("div", {
    className: "path"
  }, buildPath(prev.path)), ___EmotionJSX("div", {
    className: "name"
  }, _get(prev.item.name, menuDisplayName) || prev.item.name)))) : null, next ? ___EmotionJSX("div", null, ___EmotionJSX(Link, {
    to: next.item.route,
    href: next.item.route,
    className: "next cta"
  }, ___EmotionJSX("div", null, ___EmotionJSX("div", {
    className: "path"
  }, buildPath(next.path)), ___EmotionJSX("div", {
    className: "name"
  }, _get(next.item.name, menuDisplayName) || next.item.name)), ___EmotionJSX("div", {
    className: "icon"
  }, ___EmotionJSX("span", null, "\u203A")))) : null)) : null, updated ? ___EmotionJSX(Updated, null, "Last updated ", ___EmotionJSX(TimeAgo, {
    date: updated
  })) : null);
};

export default Footer;

if (typeof Footer !== 'undefined' && Footer && Footer === Object(Footer) && Object.isExtensible(Footer) && !Footer.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Footer, '__filemeta', {
    configurable: true,
    value: {
      name: "Footer",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/Footer/index.js"
    }
  });
}